import React, { useContext } from "react";
import { startOfWeek, format, addDays } from "date-fns";
import sv from "date-fns/locale/sv";
import { DataContext } from "../../../common/dataProvider";

const Week = ({ currentDate, cultureLocale }) => {
  const { translated } = useContext(DataContext);

  const days = [];
  const startDate = startOfWeek(currentDate, { locale: sv });
  for (let i = 0; i < 7; i++) {
    const day = format(addDays(startDate, i), translated ? "EEEE" : "E", {
      locale: cultureLocale,
    });
    days.push(
      <div
        className={translated ? "abbreviation" : "column"}
        key={i}
        aria-label={day}
      >
        <span>{day}</span>
      </div>
    );
  }
  return (
    <div
      className={`event-days row ${
        translated ? "monospace translation-row" : ""
      }`}
    >
      {days}
    </div>
  );
};

export default Week;
